// extracted by css-extract-rspack-plugin
export default {"results":"gAfL4hXW9NQDDLIr","resultsList":"EwjbN8JULgUxLamg","resultsSectionHeading":"mrHGRAcvUcMQoL0k"};